import { atomFamily } from "jotai/utils";

import { MappedUploadedPhotos } from "pages/VehicleAnalysis/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionCAIUploadedPhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<MappedUploadedPhotos>(`caiUploadedPhotos-${sessionId}`, {})
);
export const caiUploadedPhotosAtom = createDerivedSessionAtom<MappedUploadedPhotos>(sessionCAIUploadedPhotosAtom);

const sessionInjuredUploadedPhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<MappedUploadedPhotos>(`injuredUploadedPhotos-${sessionId}`, {})
);
export const injuredUploadedPhotosAtom = createDerivedSessionAtom<MappedUploadedPhotos>(
  sessionInjuredUploadedPhotosAtom
);

const sessionAuthoritiesUploadedPhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<MappedUploadedPhotos>(`authoritiesUploadedPhotos-${sessionId}`, {})
);
export const authoritiesUploadedPhotosAtom = createDerivedSessionAtom<MappedUploadedPhotos>(
  sessionAuthoritiesUploadedPhotosAtom
);
